module.exports = __webpack_public_path__ + "122dc8ea2f41f110e203585a8e36d715.svg";